export default __webpack_public_path__ + "static/media/ce-rosetta-outbound.16c8a072.png";